// project import
import { MenuFoldOutlined } from 'components/icons';
import IconButton from 'components/@extended/IconButton';
import Logo from 'components/logo';
import { cn } from 'utils/cn';

// ==============================|| DRAWER HEADER ||============================== //

interface Props {
    open: boolean;
    handleDrawerToggle?: () => void;
}

// One row in the open drawer: the logo starts where the nav icons do and the fold button sits at
// the right edge, both centred on the row. The rail shows only the logo icon, centred.
const DrawerHeader = ({ open, handleDrawerToggle }: Props) => (
    <div
        className={cn(
            'flex min-h-16 w-full shrink-0 items-center',
            open ? 'justify-between pr-2.5 pl-6' : 'justify-center'
        )}
    >
        <Logo
            isIcon={!open}
            className={open ? 'h-[30px] justify-start' : 'size-9 overflow-hidden rounded-[4px]'}
            onClick={!open ? handleDrawerToggle : undefined}
            to="/home"
        />
        {open ? (
            <IconButton
                aria-label="open drawer"
                onClick={handleDrawerToggle}
                edge="start"
                variant="light"
                className="text-primary hover:text-primary size-6 bg-transparent p-0.5 text-[20px] opacity-50 hover:bg-transparent"
            >
                <MenuFoldOutlined height={20} width={20} />
            </IconButton>
        ) : null}
    </div>
);

export default DrawerHeader;
